import Vue from 'vue';
import Router from 'vue-router';

import { AmplifyEventBus, AmplifyPlugin } from 'aws-amplify-vue';
import Amplify, * as AmplifyModules from 'aws-amplify';
import store from '@/store/';

import PageStatsMain from '@/views/PageStatsMain.vue';


Vue.use(Router);
Vue.use(AmplifyPlugin, AmplifyModules);

let user;

function getUser() {
  return Vue.prototype.$Amplify.Auth.currentAuthenticatedUser().then((data) => {
    if (data && data.signInUserSession) {
      store.commit('user/SET_USER', data);
      return data;
    }
  }).catch((error) => {
    store.commit('user/SET_USER', null);
    console.log(error);
    return null;
  });
}


const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: PageStatsMain,
      meta: { requiresAuth: true },
    },
    {
      path: '/stats-main',
      name: 'stats-main',
      component: PageStatsMain,
      meta: { requiresAuth: true },
    },

    {
      path: '/slides',
      name: 'slides',
      component: () => import(/* webpackChunkName: "PageFoundations" */ '@/views/PageSlides.vue'),
      meta: { requiresAuth: true },
    },

    {
      path: '/slides-create',
      name: 'slides-create',
      component: () => import(/* webpackChunkName: "PageFoundations" */ '@/views/PageSlidesCreate.vue'),
      meta: { requiresAuth: true },
    },

    // BEGIN: Actions
    {
      path: '/points',
      name: 'poins',
      component: () => import(/* webpackChunkName: "PageFoundations" */ '@/views/PagePoints.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/promos',
      name: 'promos',
      component: () => import(/* webpackChunkName: "PageFoundations" */ '@/views/PagePromos.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/settings-points-categories',
      name: 'settings-points-categories',
      component: () => import(/* webpackChunkName: "PageSettingsPointsCategories" */ '@/views/PageSettingsPointsCategories.vue'),
      meta: { requiresAuth: true },
    },
    // END: Actions

    {
      path: '/users',
      name: 'users',
      component: () => import(/* webpackChunkName: "PageFoundations" */ '@/views/PageUsers.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/utils-emails',
      name: 'utils-emails',
      component: () => import(/* webpackChunkName: "PageFoundations" */ '@/views/PageUtilsEmails.vue'),
      meta: { requiresAuth: true },
    },

    // BEGIN: Foundations
    {
      path: '/foundations',
      name: 'foundations',
      component: () => import(/* webpackChunkName: "PageFoundations" */ '@/views/PageFoundations.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/settings-foundations-categories',
      name: 'settings-foundations-categories',
      component: () => import(/* webpackChunkName: "PageSettingsFoundationsCategories" */ '@/views/PageSettingsFoundationsCategories.vue'),
      meta: { requiresAuth: true },
    },
    // END: Foundations

    // BEGIN: Starts
    {
      path: '/starts',
      name: 'starts',
      component: () => import(/* webpackChunkName: "PageStarts" */ '@/views/PageStarts.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/settings-starts-categories',
      name: 'settings-starts-categories',
      component: () => import(/* webpackChunkName: "PageSettingsStartsCategories" */ '@/views/PageSettingsStartsCategories.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/settings-starts-organizers',
      name: 'settings-starts-organizers',
      component: () => import(/* webpackChunkName: "PageStartsOrganizers" */ '@/views/PageStartsOrganizers.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/settings-starts-price',
      name: 'settings-starts-price',
      component: () => import(/* webpackChunkName: "PageSettingsStartsPrice" */ '@/views/PageSettingsStartsPrice.vue'),
      meta: { requiresAuth: true },
    },
    // END: Starts

    // BEGIN: Promocodes
    {
      path: '/promocodes',
      name: 'promocodes',
      component: () => import(/* webpackChunkName: "PagePromocodes" */ '@/views/PagePromocodes.vue'),
      meta: { requiresAuth: true },
    },
    // END: Promocodes

    {
      path: '/settings-tax',
      name: 'settings-tax',
      component: () => import(/* webpackChunkName: "PageSettingsTax" */ '@/views/PageSettingsTax.vue'),
      meta: { requiresAuth: true },
    },

    {
      path: '/settings-languages',
      name: 'settings-languages',
      component: () => import(/* webpackChunkName: "PageSettingsLanguages" */ '@/views/PageSettingsLanguages.vue'),
      meta: { requiresAuth: true },
    },

    {
      path: '/news',
      name: 'news',
      component: () => import(/* webpackChunkName: "PageNews" */ '@/views/PageNews.vue'),
      meta: { requiresAuth: true },
    },

    {
      path: '/news-create',
      name: 'news-create',
      component: () => import(/* webpackChunkName: "PageNewsCreate" */ '@/views/PageNewsCreate.vue'),
      meta: { requiresAuth: true },
    },

    {
      path: '/marathon-users',
      name: 'marathon-users',
      component: () => import(/* webpackChunkName: "PageMarathonUsers" */ '@/views/PageMarathonUsers.vue'),
      meta: { requiresAuth: true },
    },

    {
      path: '/signin',
      name: 'SignIn',
      component: () => import(/* webpackChunkName: "about" */ '@/views/PageSignIn.vue'),
    },
    {
      path: '/signup',
      name: 'SignUp',
      component: () => import(/* webpackChunkName: "about" */ '@/views/PageSignUp.vue'),
    },
  ],
});


getUser().then((user, error) => {
  if (user) {
    router.push({ path: '/' });
  }

  if (error) {
    console.error(error);
  }
});


AmplifyEventBus.$on('authState', async (state) => {
  if (state === 'signedOut') {
    user = null;
    AmplifyStore.commit('setUser', null);
    router.push({ path: '/signin' });
  } else if (state === 'signedIn') {
    user = await getUser();
    router.push({ path: '/' });
  }
});


router.beforeResolve(async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    user = await getUser();
    if (!user) {
      return next({
        path: '/signin',
        query: {
          redirect: to.fullPath,
        },
      });
    }
    return next();
  }
  return next();
});


export default router;
